<template>
  <div class="configure-container">
    <!-- 表格 -->
    <el-button
      type="primary"
      class="mb20"
      icon="el-icon-plus"
      @click="handleCreate"
      >新增</el-button
    >
    <DTable
      :data="tableData"
      :tableItems="tableItems"
      :pageConfig="pageConfig"
      @page-current-change="fetchData"
      @page-size-change="fetchData"
    >
      <template #header>
        <!-- 搜索表单 -->
        <DForm
          :model="searchFormModel"
          :formItems="searchFormItems"
          label-width="5em"
        >
          <template #search>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </template>
        </DForm>
      </template>

      <template slot-scope="scope" slot="status">
        <el-switch
          v-model="scope.row.status"
          :active-value="1"
          :inactive-value="0"
          @change="handleStatusChange(scope.row)"
        />
      </template>

      <!-- <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="{ row }">
          <el-button type="text" @click="handleEditCondition(row)"
            >编辑</el-button
          >
        </template>
      </el-table-column> -->
    </DTable>

    <el-dialog
      :title="detailTitle"
      :visible.sync="detailShow"
      :close-on-click-modal="false"
      append-to-body
      width="30%"
    >
      <Detail
        :formData="currentRow"
        v-if="detailShow"
        @success="handleSuccess"
      />
    </el-dialog>
  </div>
</template>

<script>
import Detail from "./detail.vue";
import { listApi, configApi } from "../indexServe";
export default {
  components: {
    Detail,
  },
  data() {
    return {
      // 搜索表单数据
      searchFormModel: {
        appName: "",
        packageName: "",
      },
      // 搜索表单配置
      searchFormItems: [
        {
          label: "应用名称",
          prop: "appName",
          type: "Input",
          span: 4,
        },
        {
          label: "应用包名",
          prop: "packageName",
          type: "Input",
          span: 4,
        },
        {
          prop: "search",
          slot: true,
          span: 4,
        },
      ],
      // 表格数据
      tableData: [],
      // 表格列配置
      tableItems: [
        {
          label: "应用名称",
          prop: "appName",
        },
        {
          label: "应用包名",
          prop: "packageName",
        },
        {
          label: "创建时间",
          prop: "createTime",
        },
        {
          label: "修改时间",
          prop: "modifyTime",
        },
        {
          label: "是否开启CPS投放",
          prop: "status",
          isSlot: true,
        },
      ],
      // 分页配置
      pageConfig: {
        page: 1,
        size: 20,
        total: 0,
      },

      detailShow: false,
      detailTitle: "",
      currentRow: {},
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 编辑定向条件
    handleEditCondition(row) {
      this.detailShow = true;
      this.currentRow = row;
    },
    handleStatusChange(row) {
      // 这里可以添加更新状态的逻辑，例如调用API更新状态
      console.log("CPS投放状态变化:", row);
      // 假设有一个API来更新状态
      configApi("update", row)
        .then(() => {
          this.$message.success("状态更新成功");
        })
        .catch(() => {
          this.$message.error("状态更新失败");
        });
    },
    initData() {
      this.fetchData();
    },
    /**获取表格数据 */
    fetchData() {
      const params = { ...this.searchFormModel, ...this.pageConfig };

      listApi(params).then((res) => {
        this.tableData = res.data.list;
        this.pageConfig.total = parseInt(res.data.total);
      });
    },
    handleCreate() {
      this.openDetail({
        status: 1,
      });
      this.detailTitle = "新增CPS投放应用";
    },
    /**编辑 */
    handleEdit(row) {
      this.openDetail(row);
      this.detailTitle = "编辑CPS投放应用";
    },

    /**打开详情 */
    openDetail(row) {
      this.detailShow = true;
      this.currentRow = row;
    },

    /**查询 */
    handleSearch() {
      this.pageConfig.page = 1;
      this.fetchData();
    },

    handleSuccess() {
      this.detailShow = false;
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
.configure-container {
  width: 100%;
  height: 100%;
}
</style>
